/**
 * @fileoverview Message ordering utilities for livechat.
 * Sorts chat interactions chronologically by timestamp.
 */

import _ from "lodash";
import moment from "moment-timezone";

interface Chat {
  interactions?: Array<any>;
  RowKey?: string;
  user_id: string;
  status: string;
}

/**
 * Sorts chat interactions in ascending chronological order.
 * Uses Timestamp or date_created field for ordering.
 *
 * @param {Chat} chat - Chat object with interactions array
 * @returns {Chat | null} Chat with sorted interactions, or null if empty
 *
 * @example
 * const orderedChat = sortMessagesAscending(chat);
 */
export function sortMessagesAscending(chat: Chat) {
  if (!_.isEmpty(chat)) {
    chat.interactions = _.orderBy(chat.interactions, (message: any) => {
      if (message.Timestamp) {
        return moment(message.Timestamp).valueOf();
      } else {
        return moment(message.date_created).valueOf();
      }
    });
    return chat;
  }
  return null;
}
